export * from './Favicons.component';
